/**
 * @typedef {Object} Angels~State
 * @property {{}} config
 */
export default {
  config: {},
}
